import logoTunefund from "assets/images/logo-tunefund.svg"
import iconTunefund from "assets/images/logo-tunefund-icon.svg"
import { KLogo } from "kahuna-base-react-components"

const TunefundLogo = ({ width, height, textVisible }: { width: number; height?: number; textVisible?: boolean }) => {
  const getLogoImg = () => {
    const url = window.location.origin
    if (url.includes("kahuna.io")) {
      return (
        <div style={{ marginTop: textVisible ? 24 : 0 }}>
          <KLogo
            width={textVisible ? width / 2.5 : width * 2.2}
            height={textVisible ? height || width / 2.5 : height || width * 2.2}
            primaryTextVisible={textVisible}
            logoColor="white"
          />
        </div>
      )
    }

    return <img src={textVisible ? logoTunefund : iconTunefund} alt="icon logo" style={{ width, height }} />
  }
  return getLogoImg()
}

export default TunefundLogo
